
import { useEffect, useState } from "react";

// import { registrosService } from "../../../_services/registros.service";
import { ComunicacionesService } from "../../../_services/comunicaciones.service";
import { Tabla } from "../../../components/Table/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTasks } from "@fortawesome/free-solid-svg-icons";
import ComunicacionesModal from "./Components/ComunicacionesModal";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { formatDate } from "../../../utils/utils";
import ArrowBack from "../../../components/ArrowBack";

const Comunicaciones = () => {
  const { user } = useSelector((state) => state.authentication);

  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [restart, setRestart] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleRecordOpen = () => setShow(true);
  const handleRecordClose = () => {
    setShow(false);
    setRestart(!restart);
  };

  useEffect(() => {
    const getData = async () => {
      let res = await ComunicacionesService.getComunicaciones();
      console.log("res", res.data);
      setData(res.data);
    };
    getData();
  }, [restart]);

  const columns = [
    {
      title: "Titulo",
      dataIndex: "titulo",
    },
    {
      title: "Apellido y Nombre",
      dataIndex: "apellido_nombre",
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      width: "14%",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      width: "30%",
    },
    {
      title: "Imnportancia",
      dataIndex: "importancia",
    },
    {
      title: "Remitente",
      dataIndex: "apellido_nombre_user",
    },
    {
      title: "Documentos",
      dataIndex: "documentos",
    },
    {
      title: "Editar",
      dataIndex: "editar",
    },
    {
      title: "Borrar",
      dataIndex: "borrar",
    },
    {
      title: "Borrado?",
      dataIndex: "borrado",
    },
  ];

  const editComunicacion = (e) => {
    const id = e.target.value;
    const record = data.find(item => item.id === parseInt(id)); // Buscar el registro por ID

    setSelectedData(record); // Almacenar los datos del registro seleccionado
    setShow(true); // Abrir el modal
  };

  const deleteComunicacion = async (e) => {
    e.preventDefault();

    await ComunicacionesService.deleteComunicacionById(e.target.value);

    setRestart(!restart);
  };

  const formatData = (arrayData) => {
    try {
      return arrayData.map(item => {
        const { toAbogado, user, registro_documentos, importancia } = item;

        return {
          ...item,
          fecha: formatDate(item.fecha),
          apellido_nombre: `${toAbogado.apellido?.toUpperCase()}, ${toAbogado.nombre}`,
          apellido_nombre_user: `${user.apellido?.toUpperCase()}, ${user.nombre} `,
          importancia: importancia?.toUpperCase(),
          // apellido_nombre_user: `${user.apellido?.toUpperCase()}, ${user.nombre} (${user.abogado})`,
          editar: (
            <Button
              variant={item.deleted ? "secondary" : "primary"}
              className={item.deleted ? "" : "bg-sn"}
              disabled={item.deleted}
              onClick={(e) => editComunicacion(e)} value={item.id}
            >
              Editar
            </Button>
          ),
          borrar: (
            <Button
              variant={item.deleted ? "secondary" : "danger"}
              disabled={item.deleted}
              onClick={(e) => deleteComunicacion(e)} value={item.id}
            >
              Borrar
            </Button>
          )
          ,
          borrado: item.deleted ? <p>Si</p> : <p>No</p>,
          documentos: registro_documentos?.length ? (
            <div>
              <ul>
                {registro_documentos.map((e, i) => {
                  return (
                    <li key={(e.name || e.documento) + i}>
                      <a
                        href={"https://staticcontent.sannicolasciudad.gob.ar/images/gestion-deudas/registros/" + e.documento}
                        key={e.documento}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {e.documento}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : null
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  return (
    <div className="section-content">
      <div className="section-title d-flex align-items-center">
        <FontAwesomeIcon icon={faTasks} style={{ fontSize: 34, color: "#999999" }} />
        <span>Nuevas Comunicaciones</span>
        {(user.rol === "admin" || user.abogado === "A00") && (<div className="w-100 d-flex justify-content-end pr-5">
          <Button className="custom-button" style={{ maxWidth: 160 }} onClick={handleRecordOpen}>Nueva Comunicación</Button>
        </div>)}
      </div>
      <ArrowBack />

      <div style={{ width: "80%" }}>
        <Tabla dataList={formatData(data)} columns={columns} />
      </div>
      {show ? (
        <ComunicacionesModal show={show} handleClose={handleRecordClose} data={selectedData} />
      ) : <></>}
    </div>
  );
};


export default Comunicaciones;